<template>
  <div :key="order.id">
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      fullscreen
      hide-overlay>
      <v-card>
        <div class="pa-3">
          <v-btn
            fab
            depressed
            x-small
            color="primary"
            @click="closeDialog">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
          <span class="title"> Previsualizador de factura</span>
        </div>
        <v-container fluid>
          <v-row>
            <v-col>
              <div
                class="title primary--text pa-2">
                Factura: {{ invoice.folio }}
              </div>
              <v-row>
                <v-col class="pt-0">
                  <v-card height="100%">
                    <div class="pa-2">
                      <v-row>
                        <v-col md="4">
                          <div>
                            Emisor:
                          </div>
                          <div class="grey--text">
                            {{ invoice.provider }}
                          </div>
                          <div class="grey--text caption">
                            {{ invoice.rfcProvider }}
                          </div>
                        </v-col>
                        <v-col md="4">
                          <div>
                            Receptor:
                          </div>
                          <div class="grey--text">
                            {{ invoice.restaurant }}
                          </div>
                          <div class="grey--text caption">
                            {{ invoice.rfcRestaurant}}
                          </div>
                        </v-col>
                        <v-col md="4">
                          <div>
                            Total a pagar:
                          </div>
                          <div  class="grey--text">
                            ${{ invoice.total | toFixNumber(2) }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-divider />
                      <v-row>
                        <v-col>
                          <v-data-table
                            :loading-text="tableInvoice.title"
                            :loading="tableInvoice.loading"
                            :headers="tableInvoice.headers"
                            :items="tableInvoice.data"
                            :options="tableInvoice.options"
                            sort-by="name"
                            class="elevation-1">
                            <template v-slot:item.quantity="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ item.quantity }}
                              </span>
                            </template>
                            <template v-slot:item.product="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ item.product }}
                              </span>
                            </template>
                            <template v-slot:item.unit="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ item.unit }}
                              </span>
                            </template>
                            <template v-slot:item.price="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ item.price | toFixNumber(2) | numberWithComma | prefix('$') }}
                              </span>
                            </template>
                            <template v-slot:item.discount="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ (item.discount || 0) | toFixNumber(2) | numberWithComma | prefix('$') }}
                              </span>
                            </template>
                            <template v-slot:item.total="{ item }">
                              <span v-bind:class="{'red--text': item.diff}">
                                {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                              </span>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <div class="title primary--text pa-2">
                Orden de compra: {{ detail.uuid }}
              </div>
              <v-row>
                <v-col class="pt-0">
                  <v-card height="100%">
                    <div class="pa-2">
                      <v-row>
                        <v-col md="4">
                          <div>
                            Emisor:
                          </div>
                          <div class="grey--text">
                            {{ detail.provider }}
                          </div>
                          <div class="grey--text caption">
                            {{ detail.rfcProvider }}
                          </div>
                        </v-col>
                        <v-col md="4">
                          <div>
                            Receptor:
                          </div>
                          <div class="grey--text">
                            {{ detail.restaurant }}
                          </div>
                          <div class="grey--text caption">
                            {{ detail.rfcRestaurant }}
                          </div>
                        </v-col>
                        <v-col md="4">
                          <div>
                            Total a pagar:
                          </div>
                          <div  class="grey--text">
                            ${{ detail.total | toFixNumber(2)}}
                          </div>
                        </v-col>
                      </v-row>
                      <v-divider />
                      <v-row>
                        <v-col>
                          <v-data-table
                            :loading-text="tableOrder.title"
                            :loading="tableOrder.loading"
                            :headers="tableOrder.headers"
                            :items="tableOrder.data"
                            :options="tableOrder.options"
                            sort-by="name"
                            class="elevation-1">
                            <template v-slot:item.amountWithTax="{ item }">
                                {{ item.amountWithTax | toFixNumber(2) | numberWithComma | prefix('$') }}
                            </template>
                            <template v-slot:item.total="{ item }">
                              {{ item.totalWithTax | toFixNumber(2) | numberWithComma | prefix('$') }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <div class="d-flex align-center justify-end">
                <v-alert type="info">
                  <div class="d-flex justify-space-between subtitle-1">
                    Nota: Los datos que se muestran en la factura remplazaran a los de la orden de compra.
                  </div>
                </v-alert>
              </div>
              <div class="d-flex align-center justify-end">
                <div class="pa-2">
                  <v-btn
                    text
                    color="primary"
                    @click="closeDialog">
                    Cargar una nueva factura
                  </v-btn>
                </div>
                <div class="pa-2">
                  <v-btn
                    color="success"
                    rounded
                    @click="upload">
                    Subir factura
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <ProductUpdateRelationInvoice
      :isOpenDialog.sync="productUpdateRelationInvoiceDialog"
      :data="diferenceProducts"
      @close="closeProductUpdateRelationInvoiceDialog"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ProductUpdateRelationInvoice from '@/components/modals/ProductUpdateRelationInvoice'

export default {
  props: {
    isOpenDialog: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Array,
      default: () => ([])
    },
    xmlFiles: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    ProductUpdateRelationInvoice
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      invoice: {},
      detail: {},
      productUpdateRelationInvoiceDialog: false,
      tableInvoice: {
        title: this.$i18n.t('sales.loading'),
        loading: false,
        headers: [
          { text: 'Insumo', value: 'product' },
          { text: 'Cantidad facturada', value: 'quantity' },
          { text: 'Unidad de medida', value: 'unit' },
          { text: 'Precio unitario (con impuestos)', value: 'price' },
          { text: 'Descuento', value: 'discount' },
          { text: 'Total', value: 'total', align: 'right' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false,
          sortBy: [''],
          sortDesc: [],
          itemsPerPage: 15,
          page: 1
        }
      },
      tableOrder: {
        title: this.$i18n.t('sales.loading'),
        loading: false,
        headers: [
          { text: 'Insumo', value: 'name' },
          { text: 'Cantidad solicitata', value: 'quantityRequested' },
          { text: 'Unidad de medida', value: 'unit.name' },
          { text: 'Precio unitario (con impuestos)', value: 'amountWithTax' },
          { text: 'Total', value: 'total', align: 'right' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false,
          sortBy: [''],
          sortDesc: [],
          itemsPerPage: 15,
          page: 1
        }
      },
      diferenceProducts: []
    }
  },
  watch: {
    isOpenDialog: async function (val) {
      this.isOpen = val
      if (val) {
        this.detail = this.data[0].order
        this.invoice = this.data[0].invoice
        this.tableInvoice.data = this.invoice.products
        this.tableOrder.data = this.detail.products
      }
    }
  },
  methods: {
    closeDialog () {
      this.isOpen = false
      this.xmlFiles = []
      this.$emit('close')
    },
    async updateProductsRelationCatalog () {
      this.overlay = true
      try {
        const response = await this.$api.post(`/v1/orders/${this.order._id}/find-different-price `)
        this.diferenceProducts = response
        if (response.length > 0) this.productUpdateRelationInvoiceDialog = true
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    upload: async function () {
      try {
        this.overlay = true
        const data = {}
        data.xmlFiles = this.xmlFiles
        if (this.order.status !== 'invalid') {
          await this.$api.post(`/v1/orders/${this.order._id}/bill`, data, { delivery: 'formData' })
        } else {
          await this.$api.post(`/v1/orders/${this.order._id}/re-bill`, data, { delivery: 'formData' })
        }
        this.$emit('uploaded')
        this.closeDialog()
        this.updateProductsRelationCatalog()
      } catch (error) {
        this.$toasted.show(error.message,
          {
            action: {
              text: 'Cerrar',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            }
          }
        )
      }
      this.overlay = false
    },
    async closeProductUpdateRelationInvoiceDialog () {
      this.productUpdateRelationInvoiceDialog = false
    }
  }
}
</script>
